import ShieldIcon from "@/components/icons/ShieldIcon";
import DOMPurify from "dompurify";
import {useAppState} from "@/store";
import {parseMergeTags} from "@/helpers";

export default function CtaLarge() {

    const content = window.ein?.content?.step_5 || {}
    const {state} = useAppState()

    const {cta_large} = content

    return (
        <div className="rounded-lg bg-brand-orange flex flex-col justify-center text-center pt-[40px] pb-[48px] px-[32px] lg:px-[200px] [&>:last-child]:mb-0">
            <div className={"bg-white rounded-full mx-auto p-[16px] mb-[16px]"}>
                <ShieldIcon className={"size-[80px]"}/>
            </div>
            <div className="heading-h2 mb-[16px]">
                {parseMergeTags(cta_large?.heading, state)}
            </div>
            <div className="heading-h3 mb-[24px]">
                {parseMergeTags(cta_large?.subheading, state)}
            </div>
            <div
                className={"[&>:last-child]:mb-0"}
                dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parseMergeTags(cta_large?.text, state))}}
            />
        </div>
    )
}
